/**
 * The plan chosen on the public pricing page, kept for the Auth0 round trip
 * (ESCLOUD-332). `appState.returnTo` carries it too; this is the fallback for
 * a direct link and for the account step when the query string was lost.
 * Session-scoped: it belongs to one visit, not to the browser.
 */

const STORAGE_KEY = 'escloud-selected-plan';

export function readSelectedPlan(): string | null {
    if (typeof window === 'undefined') return null;

    try {
        return sessionStorage.getItem(STORAGE_KEY) || null;
    } catch {
        return null;
    }
}

export function rememberSelectedPlan(planId: string): void {
    if (typeof window === 'undefined') return;

    const id = planId.trim();
    if (!id) return;

    try {
        sessionStorage.setItem(STORAGE_KEY, id);
    } catch {
        return;
    }
}

export function clearSelectedPlan(): void {
    if (typeof window === 'undefined') return;

    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch {
        return;
    }
}
